import { MultiFileDropZone } from '@dealstack/frontend/shared/components/MultiFileDropZone/MultiFileDropZone';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	onDropFile: (files: File[]) => void;
	isProcessing: boolean;
}

export const DocumentUploader = ({ onDropFile, isProcessing }: Props) => {
	const tCapManage = useTranslationCapManage();

	const handleFilesDrop = async (files: File[]) => {
		if (files.length > 0) {
			onDropFile(files);
		}
	};

	return (
		<MultiFileDropZone
			onDropFile={handleFilesDrop}
			accept={{
				'application/pdf': ['.pdf'],
			}}
			maxSize={20 * 1024 * 1024}
			disabled={isProcessing}
			icon={<Icon variant="upload-v3-thin" size="lg" />}
			primaryText={tCapManage('transactions.add_from_document.click_to_upload')}
			secondaryText={tCapManage('transactions.add_from_document.or_drag_and_drop')}
			description={tCapManage('transactions.add_from_document.pdf_max_size')}
			height="100%"
		/>
	);
};
